module.exports = __webpack_public_path__ + "img/home-01.a5eaf44a.jpg";